import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NSRouteProps } from "../../types/routeTypes";
// Components
import {
  Box,
  TextField,
  Paper,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import Title from "../../components/Title";
import Button from "../../components/Button";
import { ILoginRequest } from "../../types/authTypes";
// Icons
import { Visibility, VisibilityOff } from "@material-ui/icons";
// Utils
import { useAuth } from "../../utils/use-auth";

const Login = (props: NSRouteProps.IRouteProps) => {
  const { name } = props;
  const { login } = useAuth();
  const { t } = useTranslation();

  const [fields, setFields] = useState<ILoginRequest>({
    email: "",
    password: "",
    redirectUrl: process.env.REACT_APP_POST_LOGIN_URL,
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const updateFields = e => {
    if (e.target) {
      setFields({
        ...fields,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    login(fields);
  };

  return (
    <Box
      display="flex"
      width="100%"
      height="90vh"
      alignItems="center"
      justifyContent="center"
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onChange={updateFields}
        elevation={3}
      >
        <Box paddingY={4} paddingX={6} minWidth={350}>
          <Title name={name} />
          <Box marginBottom={2}>
            <Typography>{t("fields.email")}</Typography>
            <TextField
              type="email"
              margin="dense"
              required
              fullWidth
              placeholder={t("placeholders.enter_email")}
              name="email"
              value={fields.email}
              InputProps={{
                autoComplete: "username",
              }}
            />
          </Box>
          <Box marginBottom={2}>
            <Typography>{t("fields.password")}</Typography>
            <TextField
              type={showPassword ? "text" : "password"}
              margin="dense"
              required
              fullWidth
              placeholder={t("placeholders.enter_password")}
              name="password"
              value={fields.password}
              InputProps={{
                autoComplete: "current-password",
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={() => setShowPassword(prev => !prev)}
                      onMouseDown={e => e.preventDefault()}
                      edge="end"
                      style={{ background: "transparent" }}
                    >
                      {showPassword ? (
                        <VisibilityOff style={{ color: "#4646B4" }} />
                      ) : (
                        <Visibility style={{ color: "#4646B4" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Button
            label={t("pages.login")}
            variant="contained"
            color="primary"
            type="submit"
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
